/*
  Black Friday countdown bar.
  Counts down to fixed end times (epoch seconds rendered by Liquid in the bar's JSON),
  switches to the next phase when one ends, and shows the fallback line after the last.
  Nothing is stored: every visitor sees the same deadline.
*/
(() => {
  if (window.bfCountdownBar) return;

  const pad = (n) => (n < 10 ? '0' + n : String(n));

  const setText = (el, text) => {
    if (el && el.textContent !== text) el.textContent = text;
  };

  function initBar(bar) {
    if (bar.bfTimer !== undefined) return;

    let data;
    try {
      data = JSON.parse(bar.querySelector('[data-bf-data]').textContent);
    } catch (error) {
      return;
    }

    const phases = (data.phases || []).filter((phase) => Number(phase.end) > 0);
    const fallback = data.fallback || {};
    const el = {
      headline: bar.querySelector('[data-bf-headline]'),
      pillWrap: bar.querySelector('[data-bf-pill-wrap]'),
      pill: bar.querySelector('[data-bf-pill]'),
      pillMobile: bar.querySelector('[data-bf-pill-mobile]'),
      daysGroup: bar.querySelector('[data-bf-days-group]'),
      d: bar.querySelector('[data-bf-d]'),
      h: bar.querySelector('[data-bf-h]'),
      m: bar.querySelector('[data-bf-m]'),
      s: bar.querySelector('[data-bf-s]'),
    };
    let shownIndex = null;

    function showPhase(index) {
      shownIndex = index;
      const phase = phases[index];

      if (!phase) {
        if (!fallback.text) {
          bar.closest('.bf-bar-wrap').hidden = true;
          return;
        }
        bar.classList.add('bf-bar--fallback');
        bar.setAttribute('aria-label', fallback.label);
        return;
      }

      bar.classList.remove('bf-bar--fallback');
      bar.setAttribute('aria-label', phase.label);
      setText(el.headline, phase.headline);
      setText(el.pill, phase.pill);
      setText(el.pillMobile, phase.pillMobile);
      el.pillWrap.hidden = !phase.pill;
    }

    function tick() {
      const now = Date.now();
      let index = phases.findIndex((phase) => now < phase.end * 1000);
      if (index === -1) index = phases.length;
      if (index !== shownIndex) showPhase(index);

      const phase = phases[index];
      if (!phase) {
        bar.bfTimer = null;
        return;
      }

      const left = Math.max(0, Math.floor((phase.end * 1000 - now) / 1000));
      const days = Math.floor(left / 86400);
      el.daysGroup.hidden = days === 0;
      setText(el.d, pad(days));
      setText(el.h, pad(Math.floor((left % 86400) / 3600)));
      setText(el.m, pad(Math.floor((left % 3600) / 60)));
      setText(el.s, pad(left % 60));

      // Wake just after the next full second so the digits change on time.
      bar.bfTimer = window.setTimeout(tick, 1000 - (now % 1000) + 20);
    }

    tick();
  }

  function initAll(root) {
    root.querySelectorAll('[data-bf-countdown]').forEach(initBar);
  }

  function stopAll(root) {
    root.querySelectorAll('[data-bf-countdown]').forEach((bar) => {
      if (bar.bfTimer) window.clearTimeout(bar.bfTimer);
      bar.bfTimer = undefined;
    });
  }

  window.bfCountdownBar = { initAll };

  initAll(document);
  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
  document.addEventListener('shopify:section:unload', (event) => stopAll(event.target));
})();
